/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConsultationStrictHttpResponse } from '../../consultation-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterModel } from '../../models/encounter-model';

export interface EncounterPost$Params {
      body?: EncounterModel
}

export function encounterPost(http: HttpClient, rootUrl: string, params?: EncounterPost$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, encounterPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ConsultationStrictHttpResponse<string>;
    })
  );
}

encounterPost.PATH = '/Encounter';
